import { lazy } from 'react';

export const HierarchyList = lazy(() => import('./hierarchy/HierarchyList'));
export const ScheduledList = lazy(() => import('./scheduled/ScheduledList'));
export const CreateMaintenance = lazy(() => import('./scheduled/CreateMaintenance'));